import React, { useMemo, useState } from "react";

const cloudinaryOptimized = (src) => {
  if (!src || !src.includes("res.cloudinary.com")) return src;
  if (src.includes("f_auto")) return src;
  return src.replace("/upload/", "/upload/f_auto,q_auto/");
};

const getLowQuality = (src) => {
  if (!src || !src.includes("res.cloudinary.com")) return null;
  return src.replace("/upload/", "/upload/w_40,q_10,e_blur:1000/");
};

function StableImage({
  src,
  alt,
  className = "",
  wrapperClassName = "",
  width,
  height,
  loading = "lazy",
  fetchPriority = "auto",
  priority = false,
}) {
  const fullSrc = useMemo(() => cloudinaryOptimized(src), [src]);
  const lowSrc = useMemo(() => getLowQuality(src), [src]);

  const [loaded, setLoaded] = useState(false);

  if (!fullSrc) return null;

  return (
    <div className={`progressive-image-wrap ${wrapperClassName}`.trim()} style={{ position: "relative" }}>
      <img
        src={fullSrc}
        alt={alt}
        width={width}
        height={height}
        loading={priority ? "eager" : loading}
        fetchPriority={priority ? "high" : fetchPriority}
        decoding="async"
        className={`${className} progressive-image`.trim()}
        onLoad={() => setLoaded(true)}
      />

      {!loaded && lowSrc && (
        <img
          src={lowSrc}
          alt=""
          aria-hidden="true"
          className={`${className} progressive-image`.trim()}
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "blur(10px)",
            transform: "scale(1.03)",
            pointerEvents: "none",
          }}
        />
      )}
    </div>
  );
}

export default React.memo(StableImage);
